import { useDispatch, useSelector } from 'react-redux';

import WhiteMenu from '../../../../media/felsv/white_horizontal_menu.svg'
import DarkFileDelete from '../../../../media/felsv/dark_delete_file_icon.svg'

import { setStatusModalAnular, setStatusModalOpciones } from '../../../../actions/historial/historial.actions';
import { State } from '../../../../reducers';

export const FooterView = () => {
  const {anulado, activeFactura} = useSelector((state: State) => state.historial); 
  const dispatch = useDispatch();

  const handleMasOpciones = () => {
    dispatch(setStatusModalOpciones(true));
  }

  const handleAnular = () => {
    dispatch(setStatusModalAnular(true));
  };

  return (
    <div className='mt-16' style={{display: 'flex', justifyContent: 'end', width: '100%'}}>
      <div></div>
      <button className='m button w-inline-block w-auto' onClick={handleMasOpciones}>
        <img src={WhiteMenu} loading='lazy' alt='Más opciones'/>
        <div>Más opciones</div>
      </button>
    </div>
  )
}